
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/extensions/prefect",
      function () {
        return require("private-next-pages/extensions/prefect.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/extensions/prefect"])
      });
    }
  